import { z } from 'zod';
import { idempotency } from './spine';

const dateStr = z.string().regex(/^\d{4}-\d{2}-\d{2}$/);

export const agreementScheduleSchema = z.object({
  freq: z.enum(['monthly', 'yearly']),
  interval: z.coerce.number().int().min(1).max(24).default(1),
  months: z.array(z.number().int().min(1).max(12)).min(1).max(12).optional(),
  dayOfMonth: z.coerce.number().int().min(1).max(28).optional(),
});
export type AgreementScheduleInput = z.infer<typeof agreementScheduleSchema>;

export const billingMode = z.enum(['per_visit', 'monthly', 'annual']);

export const agreementCreateInput = idempotency.extend({
  customerId: z.string().uuid(),
  propertyId: z.string().uuid(),
  name: z.string().trim().min(1).max(120),
  schedule: agreementScheduleSchema,
  billingMode: billingMode.default('per_visit'),
  priceCents: z.coerce.number().int().min(0).max(100_000_000).default(0),
  autoCharge: z.boolean().optional(),
  startDate: dateStr,
  endDate: dateStr.optional(),
  visitTitle: z.string().trim().max(200).optional(),
});
export type AgreementCreateInput = z.infer<typeof agreementCreateInput>;

export const agreementIdInput = idempotency.extend({ agreementId: z.string().uuid() });
export type AgreementIdInput = z.infer<typeof agreementIdInput>;

export const generateOccurrencesInput = idempotency.extend({
  agreementId: z.string().uuid(),
  horizonDays: z.coerce.number().int().min(1).max(365).default(60),
});
export type GenerateOccurrencesInput = z.infer<typeof generateOccurrencesInput>;

export const skipOccurrenceInput = idempotency.extend({
  agreementId: z.string().uuid(),
  occurrenceKey: dateStr,
});
export type SkipOccurrenceInput = z.infer<typeof skipOccurrenceInput>;
